import { Cross1Icon } from "@modulz/radix-icons"
import { Box } from "../Box"
import { Card } from "../Card"
import { Flex } from "../Flex"
import { SubTitle, Text } from "../Typography"
import * as styles from "./styles"
import { StatusBarPlacement, StatusBarType } from "./styles"

export type StatusBarProps = {
  dataTestId?: string
  dismissDataTestId?: string
  message: string | JSX.Element
  onDismiss?: () => void
  placement?: StatusBarPlacement
  title?: string
  type?: StatusBarType
}

export const StatusBar = ({
  dataTestId,
  dismissDataTestId,
  message,
  onDismiss,
  placement,
  title,
  type = `info`,
}: StatusBarProps) => (
  <Card css={styles.getRootStyle(type, placement)} data-testid={dataTestId}>
    <Flex flexDirection="column" width="100%">
      {title && <SubTitle css={styles.title}>{title.toUpperCase()}</SubTitle>}
      {typeof message === `string` ? <Text css={styles.text}>{message}</Text> : <>{message}</>}
    </Flex>
    {onDismiss && (
      <Box onClick={onDismiss} data-testid={dismissDataTestId} css={styles.dismiss}>
        <Cross1Icon />
      </Box>
    )}
  </Card>
)

StatusBar.defaultProps = {
  dataTestId: undefined,
  dismissDataTestId: undefined,
  onDismiss: undefined,
  placement: undefined,
  title: undefined,
  type: `info`,
}
